import axios from "axios";


const changeUserPreferences = async (token, showHelp, recommendTuto, disclaimerAccepted, hideQuickModeAlert) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try{
    const data = await axios.post('/api/users/preferences', {
      showHelp: showHelp,
      recommendTuto: recommendTuto,
      disclaimerAccepted: disclaimerAccepted,
      hideQuickModeAlert: hideQuickModeAlert
    }, config);

    if (data.status === 200) {
      return data.data;
    }
    console.error("Erreur lors de la récupération des données");
    throw new Error("Erreur lors de la récupération des données");
  } catch(error) {
    if(error.response && error.response.status === 401){
      throw new Error(401);
    }
    if(error.response && error.response.data.message){
      console.error("Erreur : " + error.response.data.message);
    }
    throw new Error("Erreur : " + error.response?.data?.message ? error.response.data.message : "Erreur lors de la récupération des données");
  }
};

const saveAvis = async (shortId, avis, commentaire, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const data = await axios.post('/api/users/avis', { shortId, avis, commentaire }, config);
    if (data.status === 200) {
      return data.data;
    }
  } catch (error) {
    if (error.response && error.response.status === 401) {
      throw new Error(401);
    }
    if (error.response && error.response.data.message) {
      console.error("Erreur : " + error.response.data.message);
    }
    throw new Error("Erreur : " + error.response?.data?.message ? error.response.data.message : "Erreur lors de la récupération des données");
  }
};


export { changeUserPreferences, saveAvis };